var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.error)?_c('div',{staticClass:"alert alert-danger",domProps:{"innerHTML":_vm._s(_vm.error)}}):_vm._e(),_vm._v(" "),(!_vm.currentItem)?_c('return-list'):_c('return-request'),_vm._v(" "),(_vm.loading)?_c('loader'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5af92ace","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-svg-inline-loader/dist/index.min.js!./src/components/Personal/Return/ReturnComponent.vue
// module id = F1rj
// module chunks = 1